<template>
  <div class="settle-accounts-detail">
    <el-collapse v-model="activeNames" class="collapse-main-content">
      <el-collapse-item name="1">
        <template slot="title">
          <div class="collapse-title-pre">
            <span></span>
            基本信息
          </div>
        </template>
        <div class="collapse-content">
          <SiruiSearch
            ref="baseInfoFormRef"
            :query="baseFormData"
            :columns="formColumn"
            :isQueryPanel="false"
            :rules="baseFormRules"
            labelWidth="170px"
            @changeCompanyHandler="changeCompanyHandler"
            @changeDepartmentHandler="changeDepartmentHandler"
            @changeCurrencyHandler="changeCurrencyHandler"
            @changeSettlementDateHandler="changeSettlementDateHandler"
          ></SiruiSearch>
        </div>
      </el-collapse-item>

      <el-collapse-item name="2">
        <div class="collapse-content">
          <SettleAccountsRow
            ref="linesRef"
            @selectionRowHandler="selectionRowHandler"
            @closeEditTableHandler="closeRowEditTableHandler"
            @deleteTableHandler="deleteTableRowHandler"
            :baseFormData="baseFormData"
            :productList="productList"
            :isCreate="isCreate"
            :currentDetailData="currentDetailData"
            :settleAccountsDetailMap="settleAccountsDetailMap"
            :linesData="detailData.lines ? detailData.lines : []"
            @importData="importDataHandler"
          />
        </div>
      </el-collapse-item>

      <el-collapse-item name="6">
        <template slot="title">
          <div class="collapse-title-pre">
            <span></span>
            附件上传
          </div>
        </template>
        <div class="collapse-content">
          <FileTable
            ref="fileTableRef"
            :key="keyTime"
            :attachments="detailData.attachmentList"
            :isShowDownBtn="!isCreate"
            :isShowSelectBtn="isCreate"
            @viewContractFile="viewContractFile"
          />
        </div>
      </el-collapse-item>
    </el-collapse>
    <!-- 按钮组 -->
    <div class="btn-group">
      <!--      <el-button type="primary" @click="handleReject('1')">批准</el-button>-->
      <!--      <el-button type="primary" @click="handleReject('0')">驳回</el-button>-->
    </div>
  </div>
</template>

<script>
  import SettleAccountsRow from './components/SettleAccountsRow/index.vue';
  import RECEIVABLES_TRADE from '@/api/receivablesAndPayables/trade.js';
  import MANAGEMENTSTATISTICS from '@/api/managementStatistics/statistics.js';
  import baseInfoMixin from './components/BaseInfo/index.js';
  import SiruiSearch from '@/components/SiruiSearch';
  import SALE_API from '@/api/purchaseSalesCenter/purchaseSales.js';
  import WUMAOSALE_API from '@/api/purchaseSalesCenter/wumaoPurchaseSales.js';
  import wumaoMixins from '@/common/mixins/wumaoMixins';

  export default {
    name: 'JGB-managementStatistics',
    mixins: [baseInfoMixin, wumaoMixins],
    data() {
      return {
        activeNames: ['1', '2', '3', '4', '5', '6'],
        // baseFormData: {
        //   businessType: '资产出租',
        // },
        content: '',
        currentSettleAccountRowData: null, // 当前选中的行数据
        settleAccountsRowList: [], // 全部的行数据
        settleAccountsDetailMap: new Map(), // key为结算行的id,值为结算明细数组
        currentSettleAccountDetailList: [], //明细表数据
        currentStatus: '',
        currentDetailData: [], // 当前结算明细数据
        statementStatus: '', // 结算单状态
        statementIssueStatus: '', // 开票状态
        detailData: {}, // 根据id查询出来的数据
        billingInfoData: [], //根据结算单号查询出来的开票信息
        payeeInfoData: [], //根据结算单号查询出来的收款信息
        noLineDetails: false, //判断每个结算行至少要对应一个结算明细
        settlementIndex: '', //具体是哪个结算行没有结算明细
        deleteLineDetailIds: [],
        lineDetailsList: [], //所有的明细行数据
        keyTime: new Date().getTime(),
        approvalConfigName: '', //存放查询出的审批名字
        load: false,
      };
    },
    methods: {
      // 审批(批准、驳回)
      handleReject(val) {
        let params = {
          id: this.$route.query?.id,
          status: val,
        };
        this.loading.startLoading();
        this.$axios.post(MANAGEMENTSTATISTICS.MANAGEMENTSTATISTICS_APPROVAL, params).then((res) => {
          this.loading.endLoading();
          if (res.data.code === 0) {
            this.$message({
              showClose: true,
              message: res.data.msg,
              type: 'success',
            });
            this.closeTab();
          } else {
            this.$alert(res.data.msg);
          }
        });
      },
      // 撤回单据
      withdraw() {
        this.$confirm('确定要撤回吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(async () => {
            let postData = this.$route.query?.id;
            const { data } = await this.$axios.post(
              MANAGEMENTSTATISTICS.MANAGEMENTSTATISTICS_WITHDRAW,
              {
                id: postData,
              }
            );
            if (data.code === 0) {
              this.$message.success('撤回成功');
              this.closeTab();
            } else {
              this.$message.error(`${data.msg}`);
            }
          })
          .catch(() => {});
      },
      confirm(file) {
        if (file && file.length) {
          let attachmentIdList =
            this.detailData.attachmentList?.map((item) => item.attachmentId) || [];
          let attachmentList = [];
          file.forEach((item) => {
            if (!attachmentIdList.includes(item.attachmentId)) {
              attachmentList.push(item);
            }
          });
          this.$nextTick(() => {
            this.keyTime = new Date().getTime();
            if (this.detailData.attachmentList && this.detailData.attachmentList) {
              this.detailData.attachmentList = [
                ...this.detailData.attachmentList,
                ...attachmentList,
              ];
            } else {
              this.detailData.attachmentList = attachmentList;
            }
          });
        }
      },
      viewContractFile() {
        let data = this.$refs.lineDetails.getTableData();
        let dataList = data.map((item) => {
          return item.businessDocNo;
        });
        this.$refs.selectContractFileDialogRef?.openDialog('STORAGE_LADING', dataList);
      },
      // 撤回审批
      withdrawApprovalHandler() {
        this.loading.startLoading();
        this.$axios
          .post('/financial/receivableSettlement/withdrawOA', {
            businessGroup: this.userInfo.businessGroup,
            ids: [this.$route.query.id],
            oaId: this.userInfo.oaId,
          })
          .then((res) => {
            this.loading.endLoading();
            console.log(res);
            const { code, msg } = res.data;
            if (code == 0) {
              this.$message.success('撤回成功');
              this.$router.go(-1);
            } else {
              this.$message.error(msg);
            }
          })
          .catch(() => {
            this.loading.endLoading();
          });
      },
      saveDeleteLineDetailIds(val) {
        this.deleteLineDetailIds = val;
      },
      // 结算行单机一行数据
      selectionRowHandler(rowData) {
        console.log(rowData, 'rowData');
        this.currentSettleAccountRowData = rowData;
        //涉及到详情编辑的时候回显明细行
        // let lineDetails = rowData.lineDetails ? rowData.lineDetails : [];
        if (rowData) {
          const currentSettleAccountDetailList = this.settleAccountsDetailMap.get(rowData._XID);
          this.currentSettleAccountDetailList = currentSettleAccountDetailList
            ? currentSettleAccountDetailList
            : [];
        }
      },
      // 关闭行编辑的时候
      closeRowEditTableHandler(tableData, isFetchData = false) {
        if (!tableData.length) return;
        this.settleAccountsRowList = tableData;
        // 计算原币结算金额和本币计算金额
        this._computeRowTableTotalAmount(tableData);
        if (isFetchData) {
          // 把当前表格里面的lineDetails设置到map中
          for (const item of tableData) {
            // 找到当前项的lineDetails
            let currentItem = this.detailData.lines.find((it) => it.id == item.id);
            const lineDetails = currentItem?.lineDetails ? currentItem?.lineDetails : [];
            if (!this.settleAccountsDetailMap.get(item._XID)) {
              this.settleAccountsDetailMap.set(item._XID, lineDetails);
            }
          }
        }
      },
      // 关闭明细表的时候
      closeDetailEditTableHandler(tableData) {
        console.log(tableData, '监听明细中');
        this.settleAccountsDetailMap.set(this.currentSettleAccountRowData._XID, tableData);
        console.log(this.settleAccountsDetailMap, '明细中', this.currentSettleAccountRowData._XID);
        this.currentSettleAccountDetailList = tableData;
        this._computedDetailTableTotalAmount(tableData);
      },
      // 删除结算行
      deleteTableRowHandler(rowIdList, tableData) {
        console.log(rowIdList, '删除行', this.settleAccountsRowList);
        this.settleAccountsRowList = this.settleAccountsRowList.filter(
          (item) => !rowIdList.includes(item._XID)
        );
        // 计算金额
        this._computeRowTableTotalAmount(tableData);
      },
      // 导入明细表数据
      importDataHandler(importData) {
        console.log(importData, '导入明细表');
        const detailData = importData.map((item) => {
          return {
            ...item,
            propertyType: item.propertyType,
            leasedArea: item.leasedArea,
            unleasedArea: item.unleasedArea,
            selfUsedArea: item.selfUsedArea,
            revenue: item.revenue,
            rentPriceRange: item.rentPriceRange,
            remark: item.remark,
          };
        });
        // 处理下反填到数据结算表中
        this._computedDetailTableTotalAmount(detailData);
      },
      // 删除明细行
      deleteTableDetailHandler(rowIdList) {
        console.log(rowIdList, '删除明细', this.settleAccountsDetailMap);
        // 获取当当前数组项目
        const detailListItem = this.settleAccountsDetailMap.get(
          this.currentSettleAccountRowData._XID
        );
        console.log(detailListItem, '删除前');
        // 删除子项
        let newData;
        if (detailListItem && detailListItem.length) {
          newData = detailListItem.filter((item) => !rowIdList.includes(item._XID));
        }
        this.currentSettleAccountDetailList = this.currentSettleAccountDetailList.filter(
          (item) => !rowIdList.includes(item._XID)
        );
        console.log(newData, '???删除后');
        this.settleAccountsDetailMap.set(this.currentSettleAccountRowData._XID, newData);
        // 处理下反填到数据结算表中
        this._computedDetailTableTotalAmount(newData);
      },
      // 点击按钮组
      btnClickHandler(type) {
        if (type === 'save') {
          this._saveHandler();
        } else if (type === 'edit') {
          this.isCreate = true;
        } else if (type === 'approval') {
          this._saveHandler(1);
        } else if (type === 'billingApplication') {
          this._billingApplicationHandler();
        } else if (type === 'settlementLock') {
          this.lockHandler();
        } else if (type === 'resize') {
          this.isCreate = true;
        } else if (type === 'cancel') {
          this.withdrawHandler();
        } else if (type === 'close') {
          this.closeHandler();
        } else if (type === 'print') {
          this.printBtnClickHandler();
        }
        console.log(type, '点击按钮');
      },
      //打印
      printBtnClickHandler() {
        this.$refs.PrintDialog.openDialog();
      },
      DetailprintHandler(val) {
        console.log(val);
        this.loading.startLoading();
        const params = {
          id: +this.$route.query?.id,
          downloadOrPrint: 'print',
        };
        this.$axios.post(RECEIVABLES_TRADE.RECEIVABLESLIST_PRINT, params).then((res) => {
          if (res.data.code === 0) {
            this.loading.endLoading();
            if (val == 'pdf') {
              window.open(res.data.data.pdf, '_blank');
            }
            if (val == 'excel') {
              window.open(res.data.data.word, '_blank');
            }
          }
        });
      },
      //撤回
      async withdrawHandler() {
        this.$confirm('确定要撤回吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(async () => {
            let postData = [+this.$route.query?.id];
            const { data } = await this.$axios.post(RECEIVABLES_TRADE.RECEIVABLE_WITHDRAW_API, {
              ids: postData,
            });
            if (data.code === 0) {
              this.$message.success('撤回成功');
              this.$router.go(-1);
            } else {
              this.$message.error(`${data.msg}`);
            }
          })
          .catch(() => {});
      },
      //锁定
      async lockHandler() {
        this.$confirm('确定要锁定吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(async () => {
            let postData = [+this.$route.query?.id];
            const { data } = await this.$axios.post(RECEIVABLES_TRADE.RECEIVABLESLIST_LOCK, {
              ids: postData,
            });
            if (data.code === 0) {
              this.$message.success('锁定成功');
              this.$router.go(-1);
            } else if (data.code === 10000) {
              this.$message.error(`${data.msg}`);
            } else {
              this.$message.error(`${data.msg}`);
            }
          })
          .catch(() => {});
      },
      //关闭
      async closeHandler() {
        this.$confirm('确定要关闭吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(async () => {
            let postData = [+this.$route.query?.id];
            const { data } = await this.$axios.post(RECEIVABLES_TRADE.RECEIVABLESLIST_CLOSE, {
              ids: postData,
            });
            if (data.code === 0) {
              this.$message.success('关闭成功');
              this.$router.go(-1);
            } else {
              this.$message.error(`${data.msg}`);
            }
          })
          .catch(() => {});
      },
      //开票申请
      async _billingApplicationHandler() {
        if (this.baseFormData.applyInvoiceAmount >= this.baseFormData.originalTotalAmount) {
          this.$message.error('申请开票金额 (开票申请总金额)不能大于或等于原币结算金额（含税）');
          return;
        }
        let postData = [this.$route.query?.id];
        // let postData = [28];
        const { data } = await this.$axios.post(
          `${RECEIVABLES_TRADE.RECEIVABLE_BILLINGAPPLICATION_API}?businessGroup=${this.userInfo.businessGroup}`,
          postData
        );
        if (data.code == 0) {
          let path = {
            path: '/saleInvoice/add',
            name: 'saleInvoiceAdd',
            meta: {
              keepAlive: true,
              title: '创建销售开票',
            },
            query: { isEdit: 'Y', source: 'receive' },
            params: data.data,
          };
          this.$store.dispatch('tagsView/addTabView', path).then(() => {
            this.$nextTick(() => {
              this.$router.push(path);
            });
          });
        } else {
          if (data.msg) {
            return this.$message.error(data.msg);
          }
          this.$message('开票申请失败');
        }
      },
      // 保存接口 type 保存类型: 0-保存, 1-提交
      _saveHandler(type = 0) {
        console.log(this._formatSettleAccountDto(), '表格提交数据', this.settleAccountsDetailMap);
        console.log(this.$refs.linesRef.deleteLineIds, 'deleteLineIds');
        // 1.获取到基本信息数据
        this.$refs.baseInfoFormRef.validate(async (valid, baseInfoData) => {
          // this.noLineDetails = false; //判断每个结算行至少要对应一个结算明细
          // this.settlementIndex = '';
          if (!valid) {
            this.$message.error('请检查填写信息');
            return;
          }
          if (this._formatSettleAccountDto().length < 1) {
            this.$message.error('行不能为空！');
            return;
          }
          // 提交审批
          if (type == 1) {
            baseInfoData.status = '审批中';
          }
          this.loading.startLoading();
          // 上传文件表格
          const fileTable = this.$refs.fileTableRef.getTableData();
          //删除的行ids
          const deleteLineIds = this.$refs?.linesRef.deleteLineIds
            ? this.$refs?.linesRef.deleteLineIds
            : [];
          //删除的明细表ids
          let deleteLineDetailIds =
            this.$refs?.lineDetails?.deleteLineDetailIds.length > 0
              ? this.$refs?.lineDetails?.deleteLineDetailIds
              : this.deleteLineDetailIds;
          let postData = {
            ...baseInfoData,
            type,
            lines: this._formatSettleAccountDto(),
            leasingAssetsTuationList: this._formatSettleAccountDto(),
            // attachments: fileTable,
            attachmentList: fileTable,
            deleteLineIds,
            deleteLineDetailIds,
          };
          if (['edit', 'detail'].includes(this.$route.query?.status)) {
            postData.id = this.$route.query?.id;
          }
          const { data } = await this.$axios.post(
            MANAGEMENTSTATISTICS.CREATE_OR_EDIT_MANAGEMENTSTATISTICS_API,
            postData
          );

          console.log(data, '保存结果');
          if (data.code === 0) {
            this.loading.endLoading();
            this.$message.success(data.msg);
            this.closeTab();
          } else {
            this.loading.endLoading();
            this.$message.error(data.msg);
          }
        });
      },
      closeTab() {
        // 关闭当前tab导航
        this.$store.dispatch('tagsView/delView', {
          path: '/managementStatistics/detail',
          name: 'JGB-managementStatistics',
          meta: {
            keepAlive: false,
            title: '',
          },
          query: {},
        });
        this.$router.push({ path: '/todoCenter/task' });
      },
      //判断结算行中如果原币结算单价(含税)、结算数量以及明细行为空 时报错
      checkFalse() {
        let lines = this._formatSettleAccountDto();
        let checkStatus = false;
        if (lines && lines.length) {
          for (let index = 0; index < lines.length; index++) {
            const item = lines[index];
            console.log(item);
            if (!item.lineDetails?.length && !item.originalPrice && !item.settlementQuantity) {
              checkStatus = true;
              break;
            }
          }
        }
        if (checkStatus) {
          return true;
        }
      },

      // 组装结算行结算明细数据给后端
      _formatSettleAccountDto() {
        const settleAccountList = [];
        this.lineDetailsList = [];
        this.settleAccountsRowList.map((item, index) => {
          const lineDetails = this.settleAccountsDetailMap.get(item._XID);
          if (!(lineDetails && lineDetails.length)) {
            this.noLineDetails = true; //判断每个结算行至少要对应一个结算明细
            this.settlementIndex = +index + 1;
          }
          this.lineDetailsList = this.lineDetailsList.concat(lineDetails || []);
          settleAccountList.push({
            ...item,
            additional: item.additional ? 1 : 2,
            lineDetails: lineDetails ? lineDetails : [],
          });
        });
        return settleAccountList;
      },

      // 反填到表单
      _computeRowTableTotalAmount(tableData) {
        console.log(tableData);
        // 赋值给表单
        this.baseFormData = {
          ...this.baseFormData,
        };
      },
      // 反填到明细表
      _computedDetailTableTotalAmount(tableData, isNew = false) {
        console.log('_computedDetailTableTotalAmount', tableData, isNew);
        if (tableData && tableData.length) {
          for (const item of tableData) {
            this.currentDetailData.push(item);
          }
        }
      },
      // 根据id来查下数据
      async _getDetailDataById(id) {
        if (!id) return;
        this.loading.startLoading();
        const { data } = await this.$axios.post(MANAGEMENTSTATISTICS.MANAGEMENTSTATISTICS_DETAIL, {
          id: id,
        });
        this.loading.endLoading();
        // console.log(JSON.stringify(data), '基本信息');
        if (data.code == 0) {
          this.detailData = data.data;
          // 单独抽取表单数据
          const {
            address,
            businessType,
            companyCode,
            companyName,
            dataMonth,
            reportedDate,
            reportedBy,
            importBatchNo,
            remark,
          } = data.data;
          this.baseFormData = {
            address,
            businessType,
            companyCode,
            companyName,
            dataMonth,
            reportedDate,
            reportedBy,
            importBatchNo,
            remark,
          };

          this.assembleHandler(data.data);
        } else {
          this.$message.error('获取数据失败');
        }
      },
      async _getContractProduct(companyCode, departmentCode, contractNo) {
        const postData = {
          contractBusinessCompanyNo: companyCode,
          contractBusinessDepartment: departmentCode,
          exactContractNo: contractNo,
          contractCategory: 'sales',
          contractDetailCategory: 'CG04',
        };

        let api = this.isWuMaoAccount
          ? WUMAOSALE_API.STATEMENT_CONTRACT_LIST_API
          : SALE_API.STATEMENT_CONTRACT_LIST_API;
        const { data } = await this.$axios.post(api, postData);

        if (data.code == 0) {
          let orderDetailList = data.data[0].orderDetailList;
          if (orderDetailList.length) {
            orderDetailList.map((item) => {
              if (item.contractMatterName && item.contractMatter) {
                this.productList.push({
                  label: item.contractMatterName,
                  value: item.contractMatter,
                  contractDetailId: item.id,
                  taxRate: item.taxRate,
                  productModel: item.norms,
                });
              }
            });
            console.log(this.productList, 'this.productList');
          }
        }
      },
      async _getInvoiceTablelistData(receiveNo) {
        if (!receiveNo) return;
        const postData = { receivableSettlementNo: receiveNo };
        const { data } = await this.$axios.post(
          RECEIVABLES_TRADE.GET_RECEIVABLE_INVOICING_INFORMATION_BY_NO,
          postData
        );
        if (data.code == 0) {
          this.billingInfoData = data.data || [];
        } else {
          this.$message.error('获取数据失败');
        }
        console.log(data, '开票信息');
      },
      async _getCollectTablelistData(receiveNo) {
        if (!receiveNo) return;
        const postData = { settlementNo: receiveNo };
        const { data } = await this.$axios.post(
          RECEIVABLES_TRADE.GET_RECEIVABLE_COLLECTION_INFORMATION_BY_NO,
          postData
        );
        if (data.code == 0) {
          this.payeeInfoData = data.data || [];
        } else {
          this.$message.error('获取数据失败');
        }
        console.log(data, '收款信息');
      },
      //费用清单跳转过来创建结算单
      async _getBaseformData(id) {
        if (!id) return;
        // postData.id = id;
        this.loading.startLoading();
        const { data } = await this.$axios.post(MANAGEMENTSTATISTICS.MANAGEMENTSTATISTICS_DETAIL, {
          id: id,
        });
        console.log(data, '基本信息');
        if (data.code == 0) {
          this.loading.endLoading();
          // 单独抽取表单数据
          const {
            address,
            businessType,
            companyCode,
            companyName,
            dataMonth,
            reportedDate,
            reportedBy,
            remark,
          } = data.data[0];
          this.baseFormData = {
            address,
            businessType,
            companyCode,
            companyName,
            dataMonth,
            reportedDate,
            reportedBy,
            remark,
          };
          this.assembleHandler(data.data);
          console.log(data, '基本信息');
        }
      },
      //将行明细组装成行信息
      assembleHandler(tableData) {
        console.log('managementStati/detail/index.vue');
        // this.getApprovalConfig();
        console.log('approvalConfigName', this.approvalConfigName);
        console.log('personName', this.userInfo.personName);
        if (
          tableData.leasingAssetsTuationList.length > 0 &&
          tableData.leasingAssetsTuationList != null
        ) {
          const publicPath = 'leasingAssetsImport';
          const publicName = 'JGB-leasingAssetsImport';
          let path = {
            path: `/managementStati/${publicPath}`,
            name: `${publicName}`,
            meta: {
              keepAlive: true,
              title: ``,
            },
            query: {
              status: 'detail',
              id: this.$route.query?.id,
            },
          };
          if (this.approvalConfigName == this.userInfo.personName) {
            path.query.approval = true;
          }
          this.$store.dispatch('tagsView/addTabView', path).then(() => {
            this.$nextTick(() => {
              this.$router.push(path);
            });
          });
          this.closeTab();
        } else if (
          tableData.transitMaterialsStatisticsList.length > 0 &&
          tableData.transitMaterialsStatisticsList != null
        ) {
          const publicPath = 'transitMaterialsStatistics';
          const publicName = 'JGB-transitMaterialsStatistics';
          let path = {
            path: `/managementStati/${publicPath}`,
            name: `${publicName}`,
            meta: {
              keepAlive: true,
              title: ``,
            },
            query: {
              status: 'detail',
              id: this.$route.query?.id,
            },
          };
          if (this.approvalConfigName == this.userInfo.personName) {
            path.query.approval = true;
            // console.log("path===================>",path)
          }
          this.$store.dispatch('tagsView/addTabView', path).then(() => {
            this.$nextTick(() => {
              this.$router.push(path);
            });
          });
          this.closeTab();
        } else if (
          tableData.productionInformationNumberList.length > 0 &&
          tableData.productionInformationNumberList != null
        ) {
          const publicPath = 'productionInformationNumber';
          const publicName = 'JGB-productionInformationNumber';
          let path = {
            path: `/managementStati/${publicPath}`,
            name: `${publicName}`,
            meta: {
              keepAlive: true,
              title: ``,
            },
            query: {
              status: 'detail',
              id: this.$route.query?.id,
            },
          };
          if (this.approvalConfigName == this.userInfo.personName) {
            path.query.approval = true;
          }
          this.$store.dispatch('tagsView/addTabView', path).then(() => {
            this.$nextTick(() => {
              this.$router.push(path);
            });
          });
          this.closeTab();
        } else if (
          tableData.productionInformationTotalAmountList.length > 0 &&
          tableData.productionInformationTotalAmountList != null
        ) {
          const publicPath = 'productionInformationTotalAmount';
          const publicName = 'JGB-productionInformationTotalAmount';
          let path = {
            path: `/managementStati/${publicPath}`,
            name: `${publicName}`,
            meta: {
              keepAlive: true,
              title: ``,
            },
            query: {
              status: 'detail',
              id: this.$route.query?.id,
            },
          };
          if (this.approvalConfigName == this.userInfo.personName) {
            path.query.approval = true;
          }
          this.$store.dispatch('tagsView/addTabView', path).then(() => {
            this.$nextTick(() => {
              this.$router.push(path);
            });
          });
          this.closeTab();
        } else if (
          tableData.profitStatementList.length > 0 &&
          tableData.profitStatementList != null
        ) {
          const publicPath = 'profitStatement';
          const publicName = 'JGB-profitStatement';
          let path = {
            path: `/managementStati/${publicPath}`,
            name: `${publicName}`,
            meta: {
              keepAlive: true,
              title: ``,
            },
            query: {
              status: 'detail',
              id: this.$route.query?.id,
            },
          };
          if (this.approvalConfigName == this.userInfo.personName) {
            path.query.approval = true;
          }
          this.$store.dispatch('tagsView/addTabView', path).then(() => {
            this.$nextTick(() => {
              this.$router.push(path);
            });
          });
          this.closeTab();
        }
        // 赋值给表单
        this.baseFormData = {
          ...this.baseFormData,
        };
      },
      // 查询审批权限人
      async getApprovalConfig() {
        this.load = true;
        const query = {
          billType: 'managementStatistics',
          operateType: 'submit',
          pageNum: 1,
          pageSize: 10,
        };
        await this.$axios.post('/component/approvalConfig/queryPage', query).then((res) => {
          this.load = false;
          if (0 == res.data.code) {
            res.data.data.records.forEach((item) => {
              // console.log("item.approverName;",item.approverName)
              // this.approvalConfigName = item.approverName;
              // console.log("this.approvalConfigName;=====================>",this.approvalConfigName)
              if (item.approverName == this.userInfo.personName) {
                this.approvalConfigName = item.approverName;
              }
            });
          } else {
            this.$message({
              showClose: true,
              message: res.data.msg,
              type: 'error',
            });
          }
        });
      },
    },
    async mounted() {
      await this.getApprovalConfig();
      this.currentStatus = this.$route.query?.status; // 当前状态
      if (['create'].includes(this.$route.query?.status) && this.$route.query?.id?.length > 0) {
        let ids = this.$route.query?.id;
        if (ids && Array.isArray(ids) && ids.length) {
          this._getBaseformData(ids);
        } else {
          this._getBaseformData([ids]);
        }
      }
      if (['detail', 'edit'].includes(this.$route.query?.status)) {
        this._getDetailDataById(this.$route.query?.id);
      }

      if (['detail'].includes(this.$route.query?.status)) {
        this.isCreate = false;
      } else {
        this.isCreate = true;
      }
    },
    computed: {
      btnList() {
        const allBtnList = [
          {
            title: '查看',
            type: 'detail',
          },
          {
            title: '保存',
            type: 'save',
          },
          {
            title: '编辑',
            type: 'edit',
          },
          {
            title: '提交审批',
            type: 'approval',
          },
          {
            title: '开票申请',
            type: 'billingApplication',
          },
          {
            title: '结算锁定',
            type: 'settlementLock',
          },
          {
            title: '调整',
            type: 'resize',
          },
          {
            title: '撤回',
            type: 'cancel',
          },
          {
            title: '关闭',
            type: 'close',
          },
          {
            title: '打印',
            type: 'print',
          },
        ];
        // statementStatus:01-保存,02-审批中,03-已驳回,04-已通过,05-已撤回,06-已锁定,07-已关闭
        // statementIssueStatus  01-已开票,02-未开票,03-部分开票
        // billingInfoData  是否关联开票申请单   当billingInfoData.length>0就关联了 否则未关联
        // if (['create'].includes(this.currentStatus)) {
        //   return allBtnList.filter((item) => ['save'].includes(item.type));
        // }
        // if (['edit'].includes(this.currentStatus)) {
        //   return allBtnList.filter((item) => ['save', 'approval'].includes(item.type));
        // }
        if (['detail'].includes(this.currentStatus)) {
          // if (['01', '03', '05'].includes(this.statementStatus)) {
          //   // 已经保存,已驳回,已撤回
          //   return allBtnList.filter((item) => ['edit'].includes(item.type));
          // } else
          if (['04'].includes(this.statementStatus)) {
            if (this.billingInfoData.length < 1) {
              return allBtnList.filter((item) =>
                ['billingApplication', 'settlementLock', 'cancel', 'print'].includes(item.type)
              );
            } else if (
              this.billingInfoData.length > 0 &&
              ['02', '03'].includes(this.statementIssueStatus)
            ) {
              return allBtnList.filter((item) =>
                ['billingApplication', 'print'].includes(item.type)
              );
            } else if (
              this.billingInfoData.length > 0 &&
              ['01'].includes(this.statementIssueStatus)
            ) {
              return allBtnList.filter((item) => ['close', 'print'].includes(item.type));
            } else {
              return [];
            }
          }
          //  else if (['06'].includes(this.statementStatus) && this.billingInfoData.length < 1) {
          //   return allBtnList.filter((item) => ['resize'].includes(item.type));
          // }
          else {
            return [];
          }
        } else {
          return [];
        }
        // return allBtnList;
      },
      // 是否隐藏开票和收款信息
      isHiddenInfo() {
        return ['edit', 'detail'].includes(this.currentStatus);
      },
    },
    components: {
      // BaseInfo,
      SettleAccountsRow,
      // SettleAccountsInfo,
      // BillingInfo,
      // PayeeInfo,
      // FileTable,
      SiruiSearch,
      // Print,
      // printDemo,
      // SelectContractFileDialog,
    },
  };
</script>

<style lang="scss" scoped>
  .btn-group {
    padding: 20px 0px;
    box-sizing: border-box;
  }
</style>
